import React from 'react';
import { COLORS } from '../../../styles/UISystem';
import IconBack from '../../UISystem/Icons/IconBack';
import { BodySmall } from '../../UISystem/Typography';

/**
 * HeaderChat Component
 * 
 * Variants:
 * - blank: Image placeholder in MediumGray
 * - name: Image placeholder in MediumGray with BodySmall Name text
 * - full: Profile image with BodySmall Name text
 */
export const HeaderChat = ({ 
  variant = 'blank',
  name = '',
  imageUrl = '',
  onBack,
  onConnectionClick // Add new prop for connection page navigation
}) => {
  // Single strategic log to debug the issue
  console.log('HeaderChat rendering with:', { variant, name, hasName: !!name, nameLength: name?.length });
  return (
    <div style={{
      width: '100%',
      height: '80px',
      backgroundColor: 'white',
      position: 'relative',
      boxSizing: 'border-box'
    }}>
      {/* Profile image placeholder at top */}
      <div style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        position: 'absolute',
        top: '0px'
      }}>
        <div 
          onClick={onConnectionClick} // Add click handler
          style={{
            width: '57px',
            height: '57px',
            borderRadius: '50%',
            backgroundColor: COLORS.MEDIUM_GRAY,
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: onConnectionClick ? 'pointer' : 'default' // Show pointer cursor if clickable
          }}
        >
          {variant === 'full' && imageUrl ? (
            <img 
              src={imageUrl} 
              alt={name} 
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
          ) : variant === 'name' && name ? (
            <div style={{
              fontSize: '32px',
              fontWeight: '300', // Lighter weight
              color: COLORS.MEDIUM_GRAY // Medium gray color as per original design
            }}>
              {name.charAt(0).toUpperCase()}
            </div>
          ) : null}
        </div>
      </div>
      
      {/* Back arrow - centered to middle of image */}
      <div style={{
        position: 'absolute',
        left: '8px',
        top: '28px', // Position at center of image placeholder (57px/2)
        transform: 'translateY(-50%)'
      }}>
        <IconBack onClick={onBack} />
      </div>
      
      {/* Name text - only shown for name and full variants */}
      {(variant === 'name' || variant === 'full') && name && (
        <div style={{
          position: 'absolute',
          bottom: '4px',
          width: '100%',
          textAlign: 'center'
        }}>
          <BodySmall style={{ color: COLORS.MEDIUM_GRAY }}>
            {name.split(' ')[0]}
          </BodySmall>
        </div>
      )}
      
      {/* No connect button as per spec */}
    </div>
  );
};

/**
 * HeaderChatExample Component
 * 
 * Used for displaying HeaderChat examples in the UI System
 */
export const HeaderChatExample = () => {
  const handleBack = () => {
    console.log('Back button clicked');
  };
  
  return (
    <div style={{ marginBottom: '60px' }}>
      <div style={{ 
        fontSize: '24px', 
        fontWeight: 'bold', 
        color: COLORS.DARK_GRAY, 
        marginBottom: '32px',
        textAlign: 'center'
      }}>
        HeaderChat
      </div>
      
      {/* Blank example */}
      <div style={{ marginBottom: '32px' }}>
        <div style={{ 
          marginBottom: '8px', 
          fontSize: '16px', 
          color: COLORS.DARK_GRAY,
          textAlign: 'center'
        }}>
          blank
        </div>
        <HeaderChat 
          variant="blank"
          onBack={handleBack}
        />
      </div>

      {/* Name example */}
      <div style={{ marginBottom: '32px' }}>
        <div style={{ 
          marginBottom: '8px', 
          fontSize: '16px', 
          color: COLORS.DARK_GRAY,
          textAlign: 'center'
        }}>
          name
        </div>
        <HeaderChat 
          variant="name"
          name="Natalie Johnson"
          onBack={handleBack}
        />
      </div>

      {/* Full example */}
      <div style={{ marginBottom: '32px' }}>
        <div style={{ 
          marginBottom: '8px', 
          fontSize: '16px', 
          color: COLORS.DARK_GRAY,
          textAlign: 'center'
        }}>
          full
        </div>
        <HeaderChat 
          variant="full"
          name="Natalie Johnson"
          imageUrl="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=256&q=80"
          onBack={handleBack}
        />
      </div>
    </div>
  );
};
